/**
 * External dependencies
 */
import { some } from "lodash";

/**
 * Internal dependencies
 */
import getLayout from "./get-layout";
import getEdits from "./get-edits";

export default (state, layoutId) => {
  const layout = getLayout(state, layoutId);
  const edits = getEdits(state, layoutId);

  if (!edits) {
    return false;
  }

  const editsDirty = some(edits, (value, key) => {
    if (layout) {
      if (key === "items") {
        return JSON.stringify(value) !== JSON.stringify(layout.items);
      }
    }
    return false;
  });

  return editsDirty;
};
